"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _basic = _interopRequireDefault(require("./_basic"));
var _bluebird = _interopRequireDefault(require("bluebird"));
class ReportingTags extends _basic.default {
  /**
   * @constructor
   */
  constructor(_ref) {
    let {
      userTokenFactory,
      gatewayUrl,
      providersAccountId
    } = _ref;
    super({
      userTokenFactory
    });
    this.providersAccountId = providersAccountId;
    this.gatewayUrl = gatewayUrl;
  }
  get reportingTagsUrl() {
    return `${this.gatewayUrl}/${this.providersAccountId}/account-reporting-tags`;
  }
  async getReportingTags() {
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.get(this.reportingTagsUrl, headers)).then(response => _bluebird.default.resolve(response.data));
  }
  async updateReportingTags(value) {
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.put(this.reportingTagsUrl, value, headers).then(response => _bluebird.default.resolve(response.data)));
  }
}
var _default = ReportingTags;
exports.default = _default;